import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class Prompt extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            locale: this.props.locale,
            isVisible: false,
        };

        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.hide = this.hide.bind(this);
        this.onHideComplete = this.onHideComplete.bind(this);
    }

    componentDidMount() {
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.locale !== nextProps.locale){
            this.setState({locale: Object.assign({}, nextProps.locale)});
        }
    }

    componentDidUpdate() {
    }


    show() {
        let optionRef = this.refs[`prompt_${this.props.id}`];
        TweenLite.set(optionRef, {height: "auto"});
        TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
            height: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onShowComplete);
    }


    onShowComplete() {
        this.setState({isVisible: true});
        if(appHelper.isDefined(this.props.onComplete)){
            this.props.onComplete();
        }
    }

    hide() {
        let optionRef = this.refs[`prompt_${this.props.id}`];

        TweenLite.to(optionRef, 1, {
            height: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onHideComplete);
    }

    onHideComplete() {
        this.setState({isVisible: false});
    }

    render() {
        return (
            this.state.locale.description.length > 0?

                <div className={`object-container`} ref={`prompt_${this.props.id}`}>
                    <div className={`question-prompt`}>
                        <div className="content-column">
                            {
                                this.props.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0
                                    ? <h4  className="bold" dangerouslySetInnerHTML={{__html:this.state.locale.label}} />
                                    : null
                            }

                            {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                ?
                                <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                : null
                            }

                        </div>
                    </div>
                </div>
                : <div ref={`prompt_${this.props.id}`}/>

        );
    }
}

Prompt.propTypes = {
    id:PropTypes.number.isRequired,
    locale: PropTypes.object.isRequired,
    show_title:  PropTypes.bool.isRequired,
    onComplete: PropTypes.func,
    actions: PropTypes.object.isRequired
};

Prompt.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Prompt);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/Prompt.js
 **/